import { ResourceProps } from '@/libs/contentful/types';
import { RelatedArticleProps, RelatedArticleFlexibleProps } from './types';
import { ResolvedConcept } from '@/libs/contentful/rest/fetchPageREST';
import { getRichTextValue } from '@/utils/formatters';
import { getMostSpecificConcept } from '@/utils/taxonomy';
import { extractSlugFromUrl } from '@/libs/contentful/utils';

export function getMostSpecificConceptLabel(
  articleId: string,
  fallbackLabel: string,
  entryConceptIds: Map<string, string[]>,
  concepts: Map<string, ResolvedConcept>,
): string {
  const conceptIds = entryConceptIds.get(articleId);
  if (!conceptIds || conceptIds.length === 0) return fallbackLabel;

  return getMostSpecificConcept(conceptIds, concepts)?.label ?? fallbackLabel;
}

export const resourceToArticleShim = (
  item: ResourceProps | RelatedArticleProps | RelatedArticleFlexibleProps,
  taxonomyLabel?: string,
  taxonomyUri?: string,
): RelatedArticleProps => {
  const getCategory = (defaultCategory?: { label: string; url?: string }) => {
    if (taxonomyLabel) {
      return { label: taxonomyLabel, url: taxonomyUri };
    }
    return defaultCategory;
  };

  if (item.__typename === 'Resource') {
    const defaultCategory = item?.resourceLabelRte ? { label: getRichTextValue(item.resourceLabelRte) } : undefined;
    return {
      __typename: 'RelatedArticle',
      articleTitle: item.resourceCopy,
      articleImage: item.resourceIcon,
      slug: item.resourcePage?.slug || extractSlugFromUrl(item.url),
      category: getCategory(defaultCategory),
      sys: item?.sys || { id: '' },
    };
  }

  if (item.__typename === 'PageBlogPostFlexible') {
    return {
      __typename: 'RelatedArticle',
      articleTitle: item.articleTitle?.headline,
      articleImage: item.articleImage?.desktopMedia,
      slug: item.slug,
      category: getCategory(),
      categories: item.categories,
      sys: item.sys,
      publishDate: item.publishDate,
    };
  }

  const relatedArticle = item as RelatedArticleProps;
  return {
    ...relatedArticle,
    category: getCategory(relatedArticle.category),
  };
};
